// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"5d97b16c","650":"3bf4df04"}[chunkId] + ".chunk.js";
};